import { OrderRequirements } from '@order/orderTypes'
import { StateCreator } from 'zustand'

export const initialRequirementsState: OrderRequirements = {
  customerDetails: false,
  invoice: false,
}

export type OrderRequirementsActions = {
  setRequirements: (
    requirement: keyof OrderRequirements,
    value: boolean
  ) => void
}

export type OrderRequirementsState = { requirements: OrderRequirements }

const orderRequirementsSlice: StateCreator<
  OrderRequirementsActions & OrderRequirementsState,
  [['zustand/immer', never], never],
  [],
  OrderRequirementsActions & OrderRequirementsState
> = (set) => ({
  requirements: initialRequirementsState,
  setRequirements: (requirement, value) =>
    set((state) => {
      state.requirements[requirement] = value
    }),
})

export default orderRequirementsSlice
